<div class="formulario-aviso p-5 mb-5">
  <p class="title-form-pages pb-4 pt-3">
    Atendimento
  </p>
  <p>Caro cliente, você pode tirar suas dúvidas muito rapidamente acessando nossa central de Dúvidas Frequentes.
    <br>Caso tenha algum problema com algum de nossos produtos, contate o nosso SAC no número indicado abaixo.
  </p>
</div>


<div class="container mt-3">
  <div class="row">
    <div class="col-md-6 pb-3">
      <a style="text-decoration: none;" href="atendimento/fale-conosco">
        <div class="card-form">
          <img class="card-img col-33" src="../../../../assets/icons/blukit_icon.svg" alt="" />
          <div class="card-form-content-text col-8">
            <p>
              <span>Fale Conosco</span> <br>
              Para vendas, compras ou Informações gerais
            </p>
          </div>
          <img class="icon-area col-1" src="../../../../assets/icons/Icon.svg" />
        </div>
      </a>
    </div>

    <div class="col-md-6 pb-3">
      <a style="text-decoration: none;" href="atendimento/assistencia-tecnica">
        <div class="card-form">

          <img class="card-img col-3" src="../../../../assets/icons/assistencia_icon2.svg" alt="" />
          <div class="card-form-content-text col-8 ">
            <p>
              <span>Assistência Técnica </span> <br>
              Para dúvidas de produtos, defeitos e serviços técnicos
            </p>
          </div>
          <img class="icon-area col-1" src="../../../../assets/icons/Icon.svg" />
        </div>
      </a>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 pb-3">
      <a style="text-decoration: none;" href="atendimento/financeiro">
        <div class="card-form">
          <img class="card-img col-8" src="../../../../assets/icons/financeiro_icon.svg" alt="" />
          <div class="card-form-content-text col-8 ">
            <p>
              <span>Financeiro</span> <br>
              Para boletos, títulos e informações financeiras
            </p>
          </div>
          <img class="icon-area col-1" src="../../../../assets/icons/Icon.svg" />
        </div>
      </a>
    </div>

    <!-- <div class="col-md-6 pb-3">
      <a style="text-decoration: none;" href="http://novocurriculo.blukit.com.br:8080/novocurriculoweb/" target="_blank">
        <div class="card-form">

          <img class="card-img col-8" src="../../../../assets/icons/trabalhe_icon.svg" alt="" />
          <div class="card-form-content-text col-8 ">
            <p>
              <span>Trabalhe na Blukit </span> <br>
              Cadastre seu currículo e seja um candidato a vagas
            </p>
          </div>
          <img class="icon-area col-1" src="../../../../assets/icons/Icon.svg" />
        </div>
      </a>
    </div> -->
  </div>

  <div class="row">
    <div class="col-md-6 pb-3">
      <a style="text-decoration: none;" href="atendimento/duvidas-frequentes">
        <div class="card-form">
          <img class="card-img col-8" src="../../../../assets/icons/duvidas_icon.svg" alt="" />
          <div class="card-form-content-text col-8 ">
            <p>
              <span>Dúvidas Frequentes</span> <br>
              Para dúvidas de utilização ou funcionamento de produtos
            </p>
          </div>
          <img class="icon-area col-1" src="../../../../assets/icons/Icon.svg" />
        </div>
      </a>
    </div>

    <div class="col-md-6 pb-3">
      <a style="text-decoration: none;" href="atendimento/ouvidoria">
        <div class="card-form">

          <img class="card-img col-8" src="../../../../assets/icons/ouvidoria_icon.svg" alt="" />
          <div class="card-form-content-text col-8 ">
            <p>
              <span>Ouvidoria </span> <br>
              Para Informações gerais, reclamações ou elogios
            </p>
          </div>
          <img class="icon-area col-1" src="../../../../assets/icons/Icon.svg" />
        </div>
      </a>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 pb-3">

      <a style="text-decoration:none;" href="https://faleseguro.com.br/welcome?uuid=3941ff81-1ade-4673-ad17-0994d7bf5a41" target="_blank">

        <div class="card-form">

          <img class="card-img col-8" src="../../../../assets/icons/ouvidoria_icon.svg" alt="" />


          <div class="card-form-content-text col-8 " >
            <p>
              <span>Canal de Ética </span> <br>
              Canal interno para comunicação de condutas que não estão em conformidade
            </p>
          </div>
          <img class="icon-area col-1" src="../../../../assets/icons/Icon.svg" />
        </div>
      </a>
    </div>

    <div class="col-md-6 pb-3">
      <a style="text-decoration: none;" href="tel:+554733310800">
        <div class="card-form">
          <img class="card-img col-8" src="../../../../assets/icons/atendimento_icon2.svg" alt="" />
          <div class="card-form-content-text col-8 ">
            <p>
              <span>SAC (47) <span class="fone"> 3331.0800 </span></span> <br>
              Atendimento telefônico somente em horário comercial </p>
          </div>
          <img class="icon-area col-1" src="../../../../assets/icons/Icon.svg" />
        </div>
      </a>
    </div>
  </div>

</div>
